import { useAppSelector } from 'src/redux/storeHooks';

/**
 * Hook to dynamically calculate the back URL after product/variant creation based on the platform.
 * Redirects to the specific platform's listing table if valid, or falls back to /products-all.
 */
export const usePlatformBackUrl = (platformId: string | number | undefined | null) => {
  const { fetchedConnectedPlatformData, omsStoreData, mainStoreData } = useAppSelector((state: any) => state.fetchConnectedPlatform);

  // Fallback to OMS store, then Main store if platformId is not provided
  const fallbackId = omsStoreData?.id || mainStoreData?.id;
  const instanceId = Number(platformId || fallbackId || 0);

  const matchedPlatform = (fetchedConnectedPlatformData || []).find(
    (item: any) => Number(item?.id) === instanceId
  );
  const typeId = Number(matchedPlatform?.platform_info?.id || 0);

  const backUrl = (typeId > 0 && instanceId > 0)
    ? `/listing-product-table/${typeId}/${instanceId}`
    : '/products-all';

  return backUrl;
};
